/** Dispatched on web when the API client determines the session is invalid after token refresh. */
export const AUTH_EXPIRED_EVENT = 'trove:auth-expired';
/** Dispatched on web when the backend indicates email is not verified. */
export const EMAIL_NOT_VERIFIED_EVENT = 'trove:email-not-verified';
/** SessionStorage key for the email verification message shown on login/verify-email page */
export const EMAIL_VERIFICATION_MESSAGE_KEY = 'trove:email-verification-message';
/** When set, clients may redirect to verify-email instead of login */
export const REDIRECT_VERIFY_EMAIL_KEY = 'trove:redirect-verify-email';
/** SessionStorage key for generic auth/preference API error message shown on login page */
export const AUTH_ERROR_MESSAGE_KEY = 'trove:auth-error-message';
/** Extension embedded app: hash route to restore after a transient auth redirect. */
export const EXTENSION_RETURN_PATH_KEY = 'trove:extension-return-path';
